module.exports = __webpack_public_path__ + "media/snare.80c4129b.wav";